<template>
  <tbody>
    <tr>
      <td>
        <span v-if="item.numero">{{ item.numero }}</span>
        <span v-else>Pendente</span>
      </td>
      <td class="text-center">
        {{ item.registeredDate | moment("DD/MM/YYYY HH:mm") }}
      </td>
      <td class="td-limit">
        <a
          v-if="item.id"
          href="#"
          class="link-master title"
          @click.prevent="editNfse"
        >
          {{ item.cliente }}
        </a>
        <span v-else>{{ item.cliente }}</span>
      </td>
      <td class="text-center">
        <div
          class="badge badge-warning td-margin"
          v-if="item.statusNome == 'Em processamento'"
        >
          Em processamento
        </div>
        <div
          class="badge badge-primary td-margin"
          v-if="item.statusNome == 'Autorizada'"
        >
          Autorizada
        </div>
        <div
          class="badge badge-success td-margin"
          v-if="item.statusNome == 'Concluida'"
        >
          Concluida
        </div>
        <div
          class="badge badge-danger td-margin"
          v-if="item.statusNome == 'Rejeitada'"
        >
          Rejeitada
        </div>
        <div
          class="badge badge-danger td-margin"
          v-if="item.statusNome == 'Falha'"
        >
          Falha
        </div>
        <div
          class="badge badge-danger td-margin"
          v-if="item.statusNome == 'Cancelada'"
        >
          Cancelada
        </div>
      </td>
      <td class="text-center td-margin">{{ item.valorNota | currency }}</td>
      <td class="text-right td-dropdown">
        <div class="side-by-side td-dropdown">
          <button
            type="button"
            class="icon-action-btn title"
            :class="{ 'icon-pdf-missing': !item.urlPdf }"
            :title="item.urlPdf ? 'Imprimir PDF' : 'PDF nao disponivel'"
            @click="printPdf"
          >
            <i class="fa-solid fa-file-pdf"></i>
          </button>
          <button
            type="button"
            class="icon-action-btn title"
            :class="{ 'icon-xml-missing': !item.urlXml }"
            :title="item.urlXml ? 'Baixar XML' : 'XML nao disponivel'"
            @click="downloadXml"
          >
            <i class="fa-solid fa-file-code"></i>
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: "NfseListItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    printPdf() {
      if (!this.item?.urlPdf) return;

      const link = document.createElement("a");
      link.href = this.item.urlPdf;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadXml() {
      if (!this.item?.urlXml) return;

      const link = document.createElement("a");
      link.href = this.item.urlXml;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    editNfse() {
      if (!this.item?.id) return;

      const routeName =
        this.item.origem === "Prefeitura"
          ? "nfsePrefeituraUpdate"
          : "nfseNacionalUpdate";

      this.$router.push({
        name: routeName,
        params: { id: this.item.id },
      });
    },
  },
};
</script>

<style scoped>
.table td {
  height: 10px !important;
  padding-left: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 5px !important;
  padding-right: 5px !important;
  padding-left: 10px !important;
  border-bottom: 0 !important;
}

.td-dropdown {
  overflow: visible;
}

.icon-action-btn {
  border: 0;
  background: transparent;
  color: #577696;
  padding: 4px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-action-btn:hover {
  color: #335374;
}

.icon-action-btn i {
  font-size: 22px;
}

.icon-pdf-missing {
  color: #dc3545;
}

.icon-xml-missing {
  color: #dc3545;
}

.link-master {
  color: #3f529b;
  cursor: pointer;
}

.link-master:hover {
  color: #3f529b;
  text-decoration: underline;
}

.td-margin {
  margin-top: 3px;
}

.td-limit {
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
